import { customerCreate } from "./customerActions";
import Notify from "./notifyActions";
import { treeview } from "./treeviewActions";

export const POST_JOBS = "POST_JOBS";
export const postJobs = (filter, page, count, customerid, order) => ({
  type: POST_JOBS,
  payload: {
    request: {
      url: customerid ? `joblist?customerid=${customerid}` : "joblist",
      method: "POST",
      data: {
        pageno: page,
        pagesize: count,
        search: filter,
        order: { field: order.field, sorttype: order.sorttype }
      }
    }
  }
});

export const POST_JOBS_LOADMORE = "POST_JOBS_LOADMORE";
export const postJobsLoadmore = (filter, page, count, customerid, order) => ({
  type: POST_JOBS_LOADMORE,
  payload: {
    request: {
      url: customerid ? `joblist?customerid=${customerid}` : "joblist",
      method: "POST",
      data: {
        pageno: page,
        pagesize: count,
        search: filter,
        order: { field: order.field, sorttype: order.sorttype }
      }
    }
  }
});

export const POST_JOB = "POST_JOB";

export const postJob = id => {
  return (dispatch) => {
    return dispatch({
      type: POST_JOB,
      payload: {
        request: {
          mode: "no-cors",
          url: `job/${id}`,
          method: "GET"
        }
      }
    }).then(response => {
      let selectedNode = response.payload.data.selectednodeid;
      dispatch(treeview(selectedNode ? selectedNode : -1));
      return response;
    });
  };
};

export const GET_JOB_TREEVIEW = "GET_JOB_TREEVIEW";

export const getJobTreeview = (id, nodeId, includeLowerRecords) => ({
      type: GET_JOB_TREEVIEW,
      payload: {
        request: {
          mode: "no-cors",
          url: `job/treeview?jobId=${id}&nodeId=${nodeId}&includeLowerRecords=${includeLowerRecords}`,
          method: "GET"
        }
      }
    });    

    export const RESET_JOB_TREEVIEW = "RESET_JOB_TREEVIEW";

    export const resetJobTreeview = () => ({
          type: RESET_JOB_TREEVIEW,
          data: null
        });

export const JOB_METADATA_STANDARDS = "JOB_METADATA_STANDARDS";

export const metadataStandards = () => ({
  type: JOB_METADATA_STANDARDS,
  payload: {
    request: {
      url: "metadatalookup",
      method: "GET"
    }
  }
});

export const GET_DEVICES = "GET_DEVICES";

export const getDevices = () => ({
  type: GET_DEVICES,
  payload: {
    request: {
      url: "devicetype",
      method: "GET"
    }
  }
});

export const JOB_METADATA_STANDARDS_CUSTOM = "JOB_METADATA_STANDARDS_CUSTOM";

export const metadataStandardsCustom = () => ({
  type: JOB_METADATA_STANDARDS_CUSTOM,
  payload: {
    request: {
      url: "metadatacustom",
      method: "GET"
    }
  }
});

export const JOB_SAVE = "JOB_SAVE";
export const JOB_CREATE_SUCCESSFULL_TOAST = "job_create_successfull_toast";
export const jobSave = (job, customerId) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: JOB_SAVE,
        payload: {
          request: {
            url: "job",
            method: "POST",
            data: { request: job }
          }
        }
      })
        .then(response => {
          if (response.payload.data.success) {
            let searchParams = JSON.parse(
              sessionStorage.getItem("JOB_SEARCH_PARAMS")
            );
            dispatch(Notify.success(JOB_CREATE_SUCCESSFULL_TOAST));
            dispatch(
              postJobs(
                searchParams ? [...searchParams.tempSearch] : [],
                1,
                15,
                customerId,
                getState().jobReducer.jobsDefaultOrder
              )
            );
            dispatch(resetJobCreateForm());
            dispatch(treeview(-1));
            resolve();
          } else {
            reject(response.payload.data.errors);
          }
        })
        .catch(err => {
          console.log(err);
        });
    });
  };
};

export const RESET_JOB_FORM = "RESET_JOB_FORM";
export const resetJobCreateForm = () => ({
  type: RESET_JOB_FORM
});

export const JOB_EDIT = "JOB_EDIT";
export const jobEdit = jobId => {
  return (dispatch, getState) => {
    dispatch({
      type: JOB_EDIT,
      payload: {
        request: {
          url: `job/${jobId}`,
          method: "GET"
        }
      }
    }).then(response => {
      dispatch(resetClearSavedForm());
    });
  };
};

export const JOB_UPDATE = "JOB_UPDATE";
export const jobUpdate = (job, customer) => ({
  type: JOB_UPDATE,
  payload: {
    request: {
      url: "job",
      method: "PUT",
      data: { request: job }
    }
  }
});
export const JOB_UPDATE_SUCCESSFULL_TOAST = "job_update_successfull_toast";
export const jobUpdateAndList = (job, customerId) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch(jobUpdate(job))
        .then(response => {
          if (response.payload.data.success) {
            let searchParams = JSON.parse(
              sessionStorage.getItem("JOB_SEARCH_PARAMS")
            );
            dispatch(Notify.success(JOB_UPDATE_SUCCESSFULL_TOAST));
            dispatch(
              postJobs(
                searchParams ? [...searchParams.tempSearch] : [],
                1,
                15,
                customerId,
                getState().jobReducer.jobsDefaultOrder
              )
            );
            dispatch(resetJobCreateForm());
            dispatch(treeview(-1));
            resolve();
          } else {
            reject(response.payload.data.errors);
          }
        })
        .catch(err => {
          console.log(err);
        });
    });
  };
};

export const JOB_EDIT_RESET = "JOB_EDIT_RESET";
export const cancelEdit = () => ({
  type: JOB_EDIT_RESET
});

export const JOB_DELETE = "JOB_DELETE";
export const JOB_DELETE_SUCCESSFULL_TOAST = "job_delete_successfull_toast";
export const JOB_DELETE_FAILED_TOAST = "job_delete_failed_toast";

export const jobDelete = (jobId, customerId) => {
  return (dispatch, getState) => {
    dispatch({
      type: JOB_DELETE,
      payload: {
        request: {
          url: `job/${jobId}`,
          method: "DELETE"
        }
      }
    })
      .then(response => {
        if (response.payload.data.success) {
          let searchParams = JSON.parse(
            sessionStorage.getItem("JOB_SEARCH_PARAMS")
          );
          dispatch(Notify.success(JOB_DELETE_SUCCESSFULL_TOAST));
          dispatch(
            postJobs(
              searchParams ? [...searchParams.tempSearch] : [],
              1,
              15,
              customerId,
              getState().jobReducer.jobsDefaultOrder
            )
          );
          dispatch(treeview(-1));
        } else {
          dispatch(Notify.error(JOB_DELETE_FAILED_TOAST));
        }
      })
      .catch(error => {
        dispatch(Notify.error(error));
      });
  };
};

export const SET_PREV_SELETED_DEVICEID = "SET_PREV_SELETED_DEVICEID";
export const setPrevSelectedDeviceid = id => ({
  type: SET_PREV_SELETED_DEVICEID,
  payload: id
});

export const JOBS_UPLOAD_LANTEK_FILES = "JOBS_UPLOAD_LANTEK_FILES";
export const JOBS_UPLOAD_LANTEK_FILES_SUCCESSFULL_TOAST =
  "jobs_upload_lantek_files_successfull_toast";
export const JOBS_UPLOAD_LANTEK_FILES_UNSUCCESSFULL_TOAST =
  "jobs_upload_lantek_files_unsuccessfull_toast";
export const JOBS_UPLOAD_LANTEK_FILES_CONCURRENCY_EXCEPTION =
  "jobs_upload_lantek_files_concurrency_exception";
export const JOBS_UPLOAD_LANTEK_FILES_LARGE_FILESIZE_UNSUCCESSFULL_TOAST =
  "jobs_upload_lantek_files_large_filesize_unsuccessfull_toast";
export const uploadLantekFiles = (data, customerId) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: JOBS_UPLOAD_LANTEK_FILES,
        payload: {
          request: {
            url: customerId
              ? `/LantekFile?customerid=${customerId}`
              : "/LantekFile",
            method: "POST",
            headers: {
              "content-type": "multipart/form-data"
            },
            data: data
          }
        }
      })
        .then(response => {
          if (response.payload.data.success) {
            let searchParams = JSON.parse(
              sessionStorage.getItem("JOB_SEARCH_PARAMS")
            );
            dispatch(
              Notify.success(JOBS_UPLOAD_LANTEK_FILES_SUCCESSFULL_TOAST)
            );
            customerId
              ? dispatch(
                  postJobs(
                    searchParams ? [...searchParams.tempSearch] : [],
                    1,
                    15,
                    customerId,
                    getState().jobReducer.jobsDefaultOrder
                  )
                )
              : dispatch(
                  postJobs(
                    searchParams ? [...searchParams.tempSearch] : [],
                    1,
                    15,
                    null,
                    getState().jobReducer.jobsDefaultOrder
                  )
                );
            resolve();
          } else {
            if (response.payload.data.errors === "concurrency_exception") {
              dispatch(
                Notify.error(JOBS_UPLOAD_LANTEK_FILES_CONCURRENCY_EXCEPTION)
              );
            } else if (response.payload.data.errors === "error_filelarge") {
              dispatch(
                Notify.error(
                  JOBS_UPLOAD_LANTEK_FILES_LARGE_FILESIZE_UNSUCCESSFULL_TOAST
                )
              );
            } else {
              dispatch(
                Notify.error(JOBS_UPLOAD_LANTEK_FILES_UNSUCCESSFULL_TOAST)
              );
            }
            reject(response.payload.data.errors);
          }
        })
        .catch(error => {
          reject();
        });
    });
  };
};

export const GET_FILTERED_JOBS = "GET_FILTERED_JOBS";
export const getJobs = jobid => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: GET_FILTERED_JOBS,
        payload: {
          request: {
            url: `joblist?jobid=${jobid}`,
            method: "GET"
          }
        }
      }).then(res => {
        if (res.type === "GET_FILTERED_JOBS_SUCCESS") {
          resolve(res.payload.data.length);
        } else {
          resolve(false);
        }
      });
    });
  };
};

export const JOB_UPDATE_SYNC = "JOB_UPDATE_SYNC";
export const jobUpdateSync = (job, customer) => ({
  type: JOB_UPDATE_SYNC,
  payload: {
    request: {
      url: `jobsync?jobid=${job}`,
      method: "POST",
      data: { request: {} }
    }
  }
});

export const jobUpdateSyncAndList = (job, customer) => {
  let searchParams = JSON.parse(sessionStorage.getItem("JOB_SEARCH_PARAMS"));
  return (dispatch, getState) => {
    dispatch(jobUpdateSync(job)).then(response => {
      dispatch(
        postJobs(
          searchParams ? [...searchParams.tempSearch] : [],
          1,
          15,
          customer,
          getState().jobReducer.jobsDefaultOrder
        )
      );
    });
  };
};

export const JOB_RELOAD = "JOB_RELOAD";
export const JOB_RELOAD_SUCCESS = "JOB_RELOAD_SUCCESS";
export const JOB_RELOAD_FAILURE = "JOB_RELOAD_FAILURE";

export const jobReload = jobId => {
  return (dispatch, getState) => {
    dispatch({
      type: JOB_RELOAD,
      payload: {
        request: {
          url: `job/${jobId}`,
          method: "GET"
        }
      }
    }).then(response => {
      dispatch(treeview('all'));      
    });
  };
};

export const CHECK_REPORTS_CAN_BE_GENERATED = "CHECK_REPORTS_CAN_BE_GENERATED";

export const checkReportCanBeGenerated = ({ testids, selectall, jobid }) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: CHECK_REPORTS_CAN_BE_GENERATED,
        payload: {
          request: {
            url: "testimggen",
            method: "POST",
            data: { testids, selectall, jobid }
          }
        }
      }).then(response => {
        if (response.type === "CHECK_REPORTS_CAN_BE_GENERATED_SUCCESS") {
          resolve(response.payload.data);
        } else {
          reject(response.payload.data);
        }
      });
    });
  };
};

export const CHECK_REPORTS_CAN_BE_GENERATED_FOR_TREEVIEW = "CHECK_REPORTS_CAN_BE_GENERATED_FOR_TREEVIEW";
export const checkReportCanBeGeneratedForTreeview = ({ nodeId, jobId, includeChildren }) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: CHECK_REPORTS_CAN_BE_GENERATED_FOR_TREEVIEW,
        payload: {
          request: {
            url: "TestReportReadyForTreeview",
            method: "POST",
            data: { nodeId, jobId, includeChildren }
          }
        }
      }).then(response => {
        if (response.type === "CHECK_REPORTS_CAN_BE_GENERATED_FOR_TREEVIEW_SUCCESS") {
          resolve(response.payload.data);
        } else {
          reject(response.payload.data);
        }
      });
    });
  };
};

export const ADD_CUSTOMER_DETAILS_WITH_NAME_IN_BREADCRUM =
  "ADD_CUSTOMER_DETAILS_WITH_NAME_IN_BREADCRUM";
export const addCustomerDetailsWithName = ({
  isNameDisplayed,
  cId,
  cName
}) => ({
  type: ADD_CUSTOMER_DETAILS_WITH_NAME_IN_BREADCRUM,
  data: { isNameDisplayed, cId, cName }
});

export const ADD_CUSTOMER_DEATILS_IN_BREADCRUM =
  "ADD_CUSTOMER_DEATILS_IN_BREADCRUM";
export const addCustomerDetails = ({ isNameDisplayed, cId }) => ({
  type: ADD_CUSTOMER_DEATILS_IN_BREADCRUM,
  data: { isNameDisplayed, cId }
});

const RESET_JOB_LIST = "RESET_JOB_LIST";
export const resetJobList = () => ({
  type: RESET_JOB_LIST
});

export const DOWNLOAD_CSV = "download_csv";
export const downloadCsv = ({ jobId, jobName }) => {
  return (dispatch, getState) => {
    dispatch({
      type: DOWNLOAD_CSV,
      payload: {
        request: {
          mode: "no-cors",
          url: `CsvJobTest/${jobId}`,
          method: "GET"
        }
      }
    }).then(response => {
      let csvContent = response.payload.data;
      csvContent = csvContent.split("\n");
      let element = document.createElement("a");
      const blob = new Blob(csvContent, { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      element.href = url;
      element.setAttribute("download", `${jobName}.csv`);
      const csvContainer = document.getElementById("csvContainer");
      if (csvContainer) {
        csvContainer.appendChild(element);
        element.click();
        if (csvContainer.hasChildNodes()) {
          csvContainer.removeChild(csvContainer.childNodes[0]);
        }
      }
    });
  };
};

const IMAGE_RE_GERNERATION = "IMAGE_RE_GERNERATION";
const IMAGE_RE_GENERATION_INPROGRESS_HELP_TEXT =
  "image_regeneration_inprogress_help_text";
const IMAGE_RE_GENERATION_SUCCEED_HELP_TEXT =
  "image_regeneration_succeed_help_text";
export const rengernateImage = jobid => {
  return (dispatch, getState) => {
    dispatch({
      type: IMAGE_RE_GERNERATION,
      payload: {
        request: {
          mode: "no-cors",
          url: "ImageGeneration",
          method: "POST",
          data: {
            JOBID: jobid
          }
        }
      }
    })
      .then(response => {
        dispatch(Notify.success(IMAGE_RE_GENERATION_INPROGRESS_HELP_TEXT));
        dispatch(jobReload(jobid));
      })
      .catch(error => {});
  };
};

export const STORE_WIREMAP_STANDARD = "STORE_WIREMAP_STANDARD";
export const storeWiremapStandard = (jobid, standard) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: STORE_WIREMAP_STANDARD,
        payload: {
          request: {
            url: "JobWiremapColor",
            method: "POST",
            data: {
              request: {
                jobid: jobid,
                wiremapcolor: standard
              }
            }
          }
        }
      })
        .then(response => {
          dispatch(postJob(jobid));
          resolve();
        })
        .catch(ex => {
          dispatch(postJob(jobid));
          resolve();
        });
    });
  };
};

export const EXPORT_JOB = "EXPORT_JOB";
export const EXPORT_JOB_SUCCESS = "export_job_success";
export const EXPORT_JOB_FAIL = "tests_export_archive_no_test_toast";
export const exportJob = (jobId, customerId, exportCsv) => {
  let searchParams = JSON.parse(sessionStorage.getItem("JOB_SEARCH_PARAMS"));
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: EXPORT_JOB,
        payload: {
          request: {
            url: `ExportJob?jobid=${jobId}&exportcsv=${exportCsv}`,
            method: "GET"
          }
        }
      })
        .then(response => {
          if (
            response &&
            response.payload &&
            response.payload.data &&
            response.payload.data.errors) {
            if (response.payload.data.errors === "error_notest") {
              if (exportCsv) {
                dispatch(Notify.error("tests_export_csv_no_test_toast"));
              }
              else {
                dispatch(Notify.error(EXPORT_JOB_FAIL));
              }
            }
            else if (response.payload.data.errors === "error_only_recerts") {
              dispatch(Notify.error("tests_export_archive_only_recerts_toast"));
            }
          } else {
            dispatch(Notify.success(EXPORT_JOB_SUCCESS));
          }
          customerId
            ? dispatch(
                postJobs(
                  searchParams ? [...searchParams.tempSearch] : [],
                  1,
                  15,
                  customerId,
                  getState().jobReducer.jobsDefaultOrder
                )
              )
            : dispatch(
                postJobs(
                  searchParams ? [...searchParams.tempSearch] : [],
                  1,
                  15,
                  null,
                  getState().jobReducer.jobsDefaultOrder
                )
              );
        })
        .catch(ex => {
          console.log(ex);
          customerId
            ? dispatch(
                postJobs(
                  searchParams ? [...searchParams.tempSearch] : [],
                  1,
                  15,
                  customerId,
                  getState().jobReducer.jobsDefaultOrder
                )
              )
            : dispatch(
                postJobs(
                  searchParams ? [...searchParams.tempSearch] : [],
                  1,
                  15,
                  null,
                  getState().jobReducer.jobsDefaultOrder
                )
              );
        });
    });
  };
};

export const EXPORT_JOB_TREEVIEW = "EXPORT_JOB_TREEVIEW";
export const EXPORT_JOB_TREEVIEW_SUCCESS = "tooltip_export_job_in_progress";
export const EXPORT_JOB_TREEVIEW_FAIL = "tests_export_archive_no_test_toast";
export const exportJobTreeview = (jobId, nodeId, includeLowerRecords, exportCSV) => {
  let searchParams = JSON.parse(sessionStorage.getItem("JOB_SEARCH_PARAMS"));
  return (dispatch, getState) => {
    dispatch(Notify.success(EXPORT_JOB_TREEVIEW_SUCCESS));
    return new Promise((resolve, reject) => {
      dispatch({
        type: EXPORT_JOB_TREEVIEW,
        payload: {
          request: {
            url: `JobExportFromTreeview?jobId=${jobId}&nodeId=${nodeId}&includeLowerRecords=${includeLowerRecords}&exportCSV=${exportCSV}`,
            method: "GET"
          }
        }
      })
        .then(response => {
          if (
            response &&
            response.payload &&
            response.payload.data &&
            response.payload.data.errors) {
            if (response.payload.data.errors === "error_notest") {
              if (exportCSV) {
                dispatch(Notify.error("tests_export_csv_no_test_toast"));
              }
              else {
                dispatch(Notify.error(EXPORT_JOB_TREEVIEW_FAIL));
              }
            }
            else if (response.payload.data.errors === "error_only_recerts") {
              dispatch(Notify.error("tests_export_archive_only_recerts_toast"));
            }
          } else {
            window.open(response.payload.data.id);
          }
        })
        .catch(ex => {
          console.log(ex);
        });
    });
  };
};

export const DOWNLOAD_EXPORTED_JOB = "DOWNLOAD_EXPORTED_JOB";
export const downloadExportedJob = (jobId, csvFile) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: DOWNLOAD_EXPORTED_JOB,
        payload: {
          request: {
            url: `DownloadExportJobFile?jobid=${jobId}&csvfile=${csvFile}`,
            method: "GET"
          }
        }
      }).then(resp => {
        if (resp && resp.payload && resp.payload.data) {
          if ((resp.payload.data.success === false) && (resp.payload.data.errors === "error_nojob")) {
            dispatch(Notify.error("error_file_not_found", { value: (csvFile === true) ? "CSV" : "ZIP" }));
          }
          else {
            window.open(resp.payload.data);
          }
        }
      });
    });
  };
};

export const VALIDATE_LT4_JOB_NAME = "VALIDATE_LT4_JOB_NAME";
export const validateLt4JobName = jobname => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: VALIDATE_LT4_JOB_NAME,
        payload: {
          request: {
            url: `JobValidateName?jobname=${jobname}`,
            method: "GET"
          }
        }
      })
        .then(resp => {
          if (resp && resp.payload && resp.payload.data) {
            resolve(resp.payload.data.success);
          } else {
            resolve(true);
          }
        })
        .catch(ex => {
          console.log(ex);
          reject();
        });
    });
  };
};

export const JOBS_UPLOAD_COMET_FILES_SUCCESSFULL_TOAST =
  "jobs_upload_comet_files_successfull_toast";
export const JOBS_UPLOAD_COMET_FILES = "JOBS_UPLOAD_COMET_FILES";
export const uploadCometFiles = (data, customerId) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: JOBS_UPLOAD_COMET_FILES,
        payload: {
          request: {
            url: customerId
              ? `/CometBulkFile?customerid=${customerId}`
              : "/CometBulkFile",
            method: "POST",
            headers: {
              "content-type": "multipart/form-data"
            },
            data: data
          }
        }
      })
        .then(response => {
          if (response.payload.data.success) {
            let searchParams = JSON.parse(
              sessionStorage.getItem("JOB_SEARCH_PARAMS")
            );
            dispatch(Notify.success(JOBS_UPLOAD_COMET_FILES_SUCCESSFULL_TOAST));
            dispatch(treeview(-1));
            customerId
              ? dispatch(
                  postJobs(
                    searchParams ? [...searchParams.tempSearch] : [],
                    1,
                    15,
                    customerId,
                    getState().jobReducer.jobsDefaultOrder
                  )
                )
              : dispatch(
                  postJobs(
                    searchParams ? [...searchParams.tempSearch] : [],
                    1,
                    15,
                    null,
                    getState().jobReducer.jobsDefaultOrder
                  )
                );
            resolve();
          } else {
            if (response.payload.data.errors === "concurrency_exception") {
              dispatch(
                Notify.error(JOBS_UPLOAD_LANTEK_FILES_CONCURRENCY_EXCEPTION)
              );
            } else if (response.payload.data.errors === "error_filelarge") {
              dispatch(
                Notify.error(
                  JOBS_UPLOAD_LANTEK_FILES_LARGE_FILESIZE_UNSUCCESSFULL_TOAST
                )
              );
            } else {
              dispatch(
                Notify.error(JOBS_UPLOAD_LANTEK_FILES_UNSUCCESSFULL_TOAST)
              );
            }
            reject(response.payload.data.errors);
          }
        })
        .catch(error => {
          reject();
        });
    });
  };
};

export const JOBS_DEFAULT_ORDER = "JOBS_DEFAULT_ORDER";
export const updateJobsDefaultOrder = value => ({
  type: JOBS_DEFAULT_ORDER,
  payload: value
});

export const DELETED_JOB_LIST = "DELETED_JOB_LIST";
export const getDeletedJobs = (filter, page, count, order) => ({
  type: DELETED_JOB_LIST,
  payload: {
    request: {
      url: "DeletedJobList",
      method: "POST",
      data: {
        pageno: page,
        pagesize: count,
        search: filter,
        order: { field: order.field, sorttype: order.sorttype }
      }
    }
  }
});

export const RECOVER_JOB = "RECOVER_JOB";
const RECOVER_JOB_FAILED_TOAST = "recover_job_failed_toast";
const RECOVER_JOB_SUCCESS_TOAST = "restore_job_success_toast";
export const restoreDeletedJob = (jobId, pager) => {
  return (dispatch, getState) => {
    return new Promise(r => {
      dispatch({
        type: RECOVER_JOB,
        payload: {
          request: {
            url: "RecoverJob",
            method: "POST",
            data: {
              jobid: jobId
            }
          }
        }
      }).then(response => {
        if (
          response &&
          response.payload &&
          response.payload.data &&
          response.payload.data.success
        ) {
          dispatch(Notify.success(RECOVER_JOB_SUCCESS_TOAST));
          dispatch(
            getDeletedJobs(
              pager.search,
              pager.pageno,
              pager.pagesize,
              pager.order
            )
          );
        } else {
          dispatch(Notify.error(RECOVER_JOB_FAILED_TOAST));
        }
      });
    });
  };
};

export const RESET_CLEAR_SAVED_FORM = "RESET_CLEAR_SAVED_FORM";
export const resetClearSavedForm = () => ({
  type: RESET_CLEAR_SAVED_FORM
});

export const PREVIOUS_SELECTED_ROW = "PREVIOUS_SELECTED_ROW";
export const saveSelectedRow = value => ({
  type: PREVIOUS_SELECTED_ROW,
  payload: value
});

export const TEST_ID_UPLOAD_FILE = "TEST_ID_UPLOAD_FILE";
export const uploadTestIDFile = data => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: TEST_ID_UPLOAD_FILE,
        payload: {
          request: {
            url: "ImportTests",
            method: "POST",
            headers: {
              "content-type": "multipart/form-data"
            },
            data: data
          }
        }
      })
        .then(response => {
          if (response.payload.data.success) {
            resolve();
          } else reject(response.payload.data.errors);
        })
        .catch(ex => {
          reject();
        });
    });
  };
};

export const CLEAR_IMPORT_ERRORS_VALUES = "CLEAR_IMPORT_ERRORS_VALUES";
export const clearImportErrors = () => ({
  type: CLEAR_IMPORT_ERRORS_VALUES
});

// export const JOB_USER_PREFERENCE_SAVE = "JOB_USER_PREFERENCE_SAVE";
// export const STORE_WIREMAP_STANDARD = "STORE_WIREMAP_STANDARD";
// export const postUserPreference = (issignaltek, preferenceModel) => {
//   return (dispatch, getState) => {
//     return new Promise((resolve, reject) => {
//       dispatch({
//         type: JOB_USER_PREFERENCE_SAVE,
//         payload: {
//           request: {
//             url: "Preference",
//             method: "POST",
//             data: {
//               request: {
//                 issignaltek: issignaltek,
//                 preferenceModel: preferenceModel
//               }
//             }
//           }
//         }
//       })
//         .then(response => {
//           dispatch(postJob(jobid));
//           resolve();
//         })
//         .catch(ex => {
//           dispatch(postJob(jobid));
//           resolve();
//         });
//     });
//   };
// };

export const JOB_MODIFIED = "JOB_MODIFIED";
export const jobModified = (jobId) => ({
  type: JOB_MODIFIED,
  payload: {
    data: { jobId }
  }
});
